import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import BackNext from '../../Common/SubComponents/BackNext';
import { CheckboxInput } from '../../../Helpers/Inputs';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { SvgIcon } from '@mui/material';
import Timer from '../icons/timer.svg?react';
import { string, object, array as yuparray } from 'yup';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { setNestedValue } from '../Helpers/Constant';
import { ConvertStringToBoolean, ConvertBooleanToString } from '../../../Helpers/Formatters/ConvertBoolean';
import { MONTANA, VERMONT, NEVADA, MARYLAND } from '../../../Helpers/Constants/States';
import { customValidators } from '../../../Helpers/Validators/customValidators';

export default function SevenYearEligibility(props) {
    const formMethods = useForm({
        resolver: yupResolver(SevenYearEligibility.ValidationSchema),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, trigger, register, setValue } = formMethods;

    const state = props.basicInfo.state;
    const ineligibleDefault = [
        {
            type: '',
            name: [],
            numberOfChildren: '',
            nameofChildren: [],
        },
    ];

    useEffect(() => {
        props.onFieldChange("isVisible", true);
    }, [])

    const handleCheckBoxValue = (field, value) => {
        if (value) {
            const newForm = ineligibleDefault;
            newForm[0].type = field;

            props.onStepFieldChange(field, ConvertBooleanToString(value), 'ineligible', [...props.formState.ineligible, newForm[0]]);
            setValue('ineligible', [...props.formState.ineligible, newForm[0]]);
        } else {
            props.onStepFieldChange(
                field,
                value,
                'ineligible',
                props.formState.ineligible.filter((form, formIndex) => form.type !== field)
            );
            const selectedForm = props.formState.ineligible.filter((form, formIndex) => form.type === field);
            const newForms = props.formState.ineligible.filter((form, formIndex) => form.type !== field);
            let selectedFormIndex;
            if (props.formState.ineligible.length > 0) {
                selectedFormIndex = props.formState.ineligible.findIndex((form) => form.type === field);
            }
            if (selectedForm.length > 0 && selectedFormIndex >= 0) {
                register('ineligible');
                setValue('ineligible', newForms);
            }
        }
    };

    const noneOfTheAboveDisabled =
        props.formState.bipolarAffectiveDisorder === 'true' ||
        props.formState.delusionalDisorders === 'true' ||
        props.formState.psychoticDisorders === 'true' ||
        props.formState.somatoformDisorders === 'true' ||
        props.formState.eatingDisorders === 'true' ||
        props.formState.alcoholism === 'true' ||
        props.formState.schizophrenia === 'true' ||
        props.formState.anxietyDisorders === 'true' ||
        props.formState.depression === 'true' ||
        props.formState.stress === 'true' ||
        props.formState.postPartemDepression === 'true';

    if (noneOfTheAboveDisabled === true) {
        props.formState.none = 'false';
    } else {
        props.formState.none = 'true';
    }

    const getLabelForMedicalIssues = () => {
        if (state === MARYLAND) {
            return 'Within the last seven years, has anyone to be covered been diagnosed with or treated for known symptoms or known indications of mental or emotional disorders, including but not limited to the following?';
        } else if (state === MONTANA) {
            return 'Has anyone to be covered ever been diagnosed with or treated by a member of the medical profession for mental or emotional disorders, including but not limited to the following?';
        } else if (state === NEVADA) {
            return 'Has anyone to be covered ever been diagnosed with or treated by a member of the medical profession for mental or emotional disorders, including but not limited to the following:';
        } else if (state === VERMONT) {
            return 'Has anyone to be covered been diagnosed with or treated for mental or emotional disorders, including but not limited to the following:';
        } else {
            return 'In the past 7 years have you been diagnosed, received care or treatment for, or consulted with or been advised to seek treatment by a licensed member of the medical profession for';
        }
    };

    const getIneligibleComponent = (field, list) => {
        let item;
        list.map((ineligible, index) => {
            if (ineligible.type === field) {
                item = ineligible;
                item.index = index;
            }
        });
        const handleValueChangeloop = (field, type, value, longFieldName) => {
            setValue(longFieldName, value);
            props.onFieldChange(
                'ineligible',
                props.formState.ineligible.map((form, formIndex) => {
                    if (type === form.type) {
                        if (field === "name")
                            form[field] = value;
                        else
                            setNestedValue(form, field, value);
                        return form;
                    } else {
                        return form;
                    }
                })
            );
        };
        const handleChildrenNames = (field, type, value, longFieldName) => {
            const resetIneligible = props.formState.ineligible.map((form, formIndex) => {
                if (type === form.type) {
                    if (field === 'numberOfChildren') {
                        setNestedValue(form, field, value);
                        const previousChildLength = form.nameofChildren.length;
                        const totalChild = parseInt(value);
                        if (totalChild > previousChildLength) {
                            const addChildInput = totalChild - previousChildLength;
                            for (let i = 1; i <= addChildInput; i++) {
                                if (type === form.type) {
                                    form.nameofChildren.push({ name: '' });
                                }
                            }
                        } else {
                            const removeChildInput = previousChildLength - totalChild;
                            form.nameofChildren.splice(`-${removeChildInput}`);
                        }
                        return form;
                    }
                } else {
                    if (type === form.type) {
                        setNestedValue(form, field, value);
                        return form;
                    } else {
                        return form;
                    }
                }
            })
            props.onFieldChange('ineligible', resetIneligible);
            setValue('ineligible', resetIneligible);
        };
        if (item) {
            return (
                <div>
                    <IneligibleForm
                        formState={item}
                        onChange={(field, value, type, longFieldName) => {
                            handleValueChangeloop(field, type, value, longFieldName);
                        }}
                        ChildChange={(field, value, type, longFieldName) => {
                            handleChildrenNames(field, type, value, longFieldName);
                        }}
                        allProps={props}
                        trigger={trigger}
                        key={item.index}
                        index={item.index}
                        customOption={props.getListOfPlanIncludedPerson()}
                        noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
                    />
                </div>
            );
        }
    };

    return (
        <Container fluid className="border-class sevenYearEligibility">
            <Row className="justify-content-center">
                <Col>
                    <FormProvider {...formMethods}>
                        <Form className="formPage" onSubmit={handleSubmit(props.onNext)}>
                            <Row className="justify-content-center mt-4">
                                <Col lg={6}>
                                    <div className="text-center mb-2 pt-4">
                                        {' '}
                                        <SvgIcon component={Timer} className="small-icons" color="primary" fontSize="large" />
                                    </div>
                                    <div className="text-center form-title pb-2">Mental and Emotional Medical History</div>
                                </Col>
                            </Row>
                            <Row className="formPage justify-content-center">
                                <Col lg={5}>
                                    {/* <FormControl component="fieldset"> */}
                                    <h6 className='pb-1'>{getLabelForMedicalIssues()}</h6>
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="bipolarAffectiveDisorder"
                                            id="bipolarAffectiveDisorder"
                                            checked={ConvertStringToBoolean(props.formState.bipolarAffectiveDisorder)}
                                            onChange={(e) => handleCheckBoxValue('bipolarAffectiveDisorder', e.target.checked)}
                                            label="Bipolar affective disorder (manic depressive syndrome)"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.bipolarAffectiveDisorder) && getIneligibleComponent('bipolarAffectiveDisorder', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="delusionalDisorders "
                                            id="delusionalDisorders"
                                            checked={ConvertStringToBoolean(props.formState.delusionalDisorders)}
                                            onChange={(e) => handleCheckBoxValue('delusionalDisorders', e.target.checked)}
                                            label="Delusional (paranoid) disorders "
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.delusionalDisorders) && getIneligibleComponent('delusionalDisorders', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="psychoticDisorders"
                                            id="psychoticDisorders"
                                            checked={ConvertStringToBoolean(props.formState.psychoticDisorders)}
                                            onChange={(e) => handleCheckBoxValue('psychoticDisorders', e.target.checked)}
                                            label="Psychotic disorders"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.psychoticDisorders) && getIneligibleComponent('psychoticDisorders', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="somatoformDisorders"
                                            id="somatoformDisorders"
                                            checked={ConvertStringToBoolean(props.formState.somatoformDisorders)}
                                            onChange={(e) => handleCheckBoxValue('somatoformDisorders', e.target.checked)}
                                            label="Somatoform disorders (psychosomatic illness)"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.somatoformDisorders) && getIneligibleComponent('somatoformDisorders', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="eatingDisorders"
                                            id="eatingDisorders"
                                            checked={ConvertStringToBoolean(props.formState.eatingDisorders)}
                                            onChange={(e) => handleCheckBoxValue('eatingDisorders', e.target.checked)}
                                            label="Eating disorders"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.eatingDisorders) && getIneligibleComponent('eatingDisorders', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="alcoholism"
                                            id="alcoholism"
                                            checked={ConvertStringToBoolean(props.formState.alcoholism)}
                                            onChange={(e) => handleCheckBoxValue('alcoholism', e.target.checked)}
                                            label="Alcoholism"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.alcoholism) && getIneligibleComponent('alcoholism', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="schizophrenia"
                                            id="schizophrenia"
                                            checked={ConvertStringToBoolean(props.formState.schizophrenia)}
                                            onChange={(e) => handleCheckBoxValue('schizophrenia', e.target.checked)}
                                            label="Schizophrenia"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.schizophrenia) && getIneligibleComponent('schizophrenia', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="anxietyDisorders"
                                            id="anxietyDisorders"
                                            checked={ConvertStringToBoolean(props.formState.anxietyDisorders)}
                                            onChange={(e) => handleCheckBoxValue('anxietyDisorders', e.target.checked)}
                                            label="Anxiety disorders"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.anxietyDisorders) && getIneligibleComponent('anxietyDisorders', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="depression"
                                            id="depression"
                                            checked={ConvertStringToBoolean(props.formState.depression)}
                                            onChange={(e) => handleCheckBoxValue('depression', e.target.checked)}
                                            label="Depression"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.depression) && getIneligibleComponent('depression', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="stress"
                                            id="stress"
                                            checked={ConvertStringToBoolean(props.formState.stress)}
                                            onChange={(e) => handleCheckBoxValue('stress', e.target.checked)}
                                            label="Stress"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.stress) && getIneligibleComponent('stress', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="postPartemDepression"
                                            id="postPartemDepression"
                                            checked={ConvertStringToBoolean(props.formState.postPartemDepression)}
                                            onChange={(e) => handleCheckBoxValue('postPartemDepression', e.target.checked)}
                                            label="Post-partem depression"
                                        />
                                    </div>
                                    {ConvertStringToBoolean(props.formState.postPartemDepression) && getIneligibleComponent('postPartemDepression', props.formState.ineligible)}
                                    <div className="checkboxes">
                                        <CheckboxInput
                                            name="none"
                                            id="none"
                                            checked={noneOfTheAboveDisabled === true ? false : true}
                                            //checked={ConvertStringToBoolean(props.formState.none)}
                                            onChange={(e) => handleCheckBoxValue('none', e.target.checked)}
                                            label="None of the above"
                                            disabled={noneOfTheAboveDisabled}
                                        />
                                    </div>
                                    {/* </FormControl> */}
                                </Col>
                            </Row>
                            <div className='backnext-wrapper'>
                                <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
                            </div>
                        </Form>
                    </FormProvider>
                </Col>
            </Row>
        </Container >
    );
}

SevenYearEligibility.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

SevenYearEligibility.ValidationSchema = object().shape({
    ineligible: yuparray(
        object().shape({
            name: yuparray().of(string().required('Name is required.')).min(1, 'Name is required.'),
            numberOfChildren: string().when('name', {
                is: (name) => name && name.includes('Dependent Child'),
                then: (schema) => schema.required('This field is required.'),
                otherwise: (schema) => schema.notRequired(),
            }),
            nameofChildren: yuparray().when('name', {
                is: (name) => name && name.includes('Dependent Child'),
                then: (schema) => yuparray(
                    object().shape({
                        name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
                    })
                ),
            }),
        })
    ),
});

SevenYearEligibility.DefaultFormState = (prefill = false) => {
    return {
        bipolarAffectiveDisorder: 'false',
        delusionalDisorders: 'false',
        psychoticDisorders: 'false',
        somatoformDisorders: 'false',
        eatingDisorders: 'false',
        alcoholism: 'false',
        schizophrenia: 'false',
        anxietyDisorders: 'false',
        depression: 'false',
        stress: 'false',
        postPartemDepression: 'false',
        none: 'true',
        ineligible: [],
        isVisible: false,
    };
};
